const prefix = 'cvf-admin/projects/';

export const SET_ACTIVE_PROJECT_ID = `${prefix}SET_ACTIVE_PROJECT_ID`;

export const GET_PROJECT_DETAILS = `${prefix}GET_PROJECT_DETAILS`;
export const GET_PROJECT_DETAILS_SUCCESS = `${prefix}GET_PROJECT_DETAILS_SUCCESS`;
export const GET_PROJECT_DETAILS_ERROR = `${prefix}GET_PROJECT_DETAILS_ERROR`;

export const GET_ALL_PROJECTS = `${prefix}GET_ALL_PROJECTS`;
export const GET_ALL_PROJECTS_SUCCESS = `${prefix}GET_ALL_PROJECTS_SUCCESS`;
export const GET_ALL_PROJECTS_ERROR = `${prefix}GET_ALL_PROJECTS_ERROR`;

export const VALIDATE_PROJECT_ID = `${prefix}VALIDATE_PROJECT_ID`;
